import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Injectable } from '@angular/core';
import { ApiService } from '../../../services/api/api.service';
import { mergeMap } from 'rxjs/operators';
import { GetDressCodePicturesAction } from '../../actions/dress-code-pictures/get-dress-code-pictures-action';
import { DeleteDressCodePictureAction } from '../../actions/dress-code-pictures/delete-dress-code-picture-action';
import { DeleteDressCodePictureErrorAction } from '../../actions/dress-code-pictures/delete-dress-code-picture-error-action';

@Injectable()
export class DeleteDressCodePictureEffect {
  constructor(private api: ApiService, private actions: Actions) {
  }


  public DeleteDressCodePicture = createEffect(() => this.actions
    .pipe(
      ofType(DeleteDressCodePictureAction.type),
      mergeMap(action => {
        const deleteDressCodePictureAction = <DeleteDressCodePictureAction>action;
        return this.api.deleteDressCodePicture(deleteDressCodePictureAction.dressCodePicture.id).then(() => {
          return new GetDressCodePicturesAction(deleteDressCodePictureAction.bijbEvent);
        }, error => {
          return new DeleteDressCodePictureErrorAction(error);
        });
      })
    ));
}
